import React from 'react';
import ReactDOM from 'react-dom';
import pic from '../shared/Pic';

class UcPic extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default pic(UcPic, 'uc');


// WEBPACK FOOTER //
// ./src/components/sections/uc/UcPic.js